import { render, staticRenderFns } from "./automaticTags.vue?vue&type=template&id=5badb37d"
import script from "./automaticTags.vue?vue&type=script&lang=js"
export * from "./automaticTags.vue?vue&type=script&lang=js"
import style0 from "./automaticTags.vue?vue&type=style&index=0&id=5badb37d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports